import { createContext } from 'react';

export const RichSlateBrandBriefsContext = createContext(null);
